// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.weak-map.constructor');



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/modules/es.weak-map.js
// module id = 1214
// module chunks = 0